import { render, staticRenderFns } from "./functionSetting.vue?vue&type=template&id=4a7f64d8&scoped=true"
import script from "./functionSetting.vue?vue&type=script&lang=js"
export * from "./functionSetting.vue?vue&type=script&lang=js"
import style0 from "./functionSetting.vue?vue&type=style&index=0&id=4a7f64d8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7f64d8",
  null
  
)

export default component.exports